<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Change e-mail"
    :closeOnBgClick="false"
  >
    <template slot="body" class="content">
      <BForm :elements="form" @valid="form.valid = $event"></BForm>
    </template>
    <template slot="footer" class="content">
      <div
        :disabled="!form.valid || isLoading"
        :class="{ 'is-loading': isLoading }"
        class="button is-primary"
        @click="save()"
      >
        Change
      </div>
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>

<script>
import { postApi } from "@/utils/http";
import { logout } from "@/utils/auth";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BForm: () => import("@/components/singles/BForm/component.vue"),
    Modal: () => import("@/components/main/Modal.vue"),
  },

  data() {
    return {
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            icon: "mdi-lock",
            label: null,
            name: "email",
            placeholder: "New e-mail (username)",
            type: "email",
            validation: "required|confirmed:confirmation",
            value: "",
            focus: true,
          },
        ],
      },
    };
  },
  created() {},

  mounted() {},
  methods: {
    async save() {
      if (this.form.valid && !this.isLoading) {
        try {
          this.isLoading = true;
          await postApi("changeusername", {
            email: this.form.inputs[0].value,
          });

          this.hide();

          this.$helpers.notify(
            "Success",
            `The username/e-mail has been changed. Please login with your new email: ${this.form.inputs[0].value}`,
            "success"
          );

          logout(false);
        } catch ({ response }) {
          if (response.status == 500) {
            this.$helpers.notify(
              "Error",
              "Internal server error, please try again later.",
              "danger"
            );
          } else if (response.status == 409) {
            this.$helpers.notify(
              "Warning",
              "This e-mail is not available. Try another.",
              "warning"
            );
          } else if (response.status == 400) {
            this.$helpers.notify("Error", "Missing parameter.", "danger");
          }

          this.form.inputs[0].value = "";
        }

        this.isLoading = false;
      }
    },
    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    },
  },
};
</script>
